export const aciIsoAlmundo = {
    iconName: 'iso-almundo',
    iconData: [
        128,
        128,
        `M64.001 4.75c-32.725 0-59.25 26.526-59.25 59.246 0 32.724 26.525 59.254 59.25 59.254 32.717 0 59.248-26.53 59.248-59.254 0-32.72-26.531-59.246-59.248-59.246zm26.341 85.411L64.373 112.43 51.536 99.367s27.09-22.525 27.233-22.648c4.952-4.188 6.769-9.104 7.228-14.869.467-5.762-1.396-11.329-5.247-15.685-4.199-4.751-10.207-7.478-16.483-7.478-5.3 0-10.53 1.962-14.729 5.531-9.177 7.799-9.815 21.984-1.42 31.665l.136.117h20.731l-22.63 18.797c-3.801-1.758-8.814-5.893-13.47-11.148-13.465-15.238-11.178-38.883 5.103-52.72 7.384-6.272 16.612-9.72 25.998-9.72 21.622 0 34.167 14.979 38.257 27.638 3.764 11.641 3.41 27.228-11.901 41.314z`,
    ],
};
